export default {"src":"/_next/static/media/auth-bg.58bd2926.svg","height":629,"width":850,"blurWidth":0,"blurHeight":0};